import { env } from '@/utils/constants/env';
import { DiagramBpmn } from 'alurkerja-ui';

export default function DiagramTask({
  show,
  processKey,
  taskKey,
}: {
  show: boolean;
  processKey?: string;
  taskKey?: string;
}) {
  return (
    <div className={`${show ? 'block' : 'hidden'}`}>
      <DiagramBpmn url={env.apiTasklistBaseUrl + `/api/v1/tasklist/${processKey}`} currentEvent={taskKey} />
    </div>
  );
}
